import { Injectable } from '@angular/core';
import { State } from 'app/core/state';
import {
    WellSchematic,
    WellSchematicApplication,
    WellSchematicDiagram,
    WellSchematicDiagramRecord,
} from 'app/modules/well-schematic-diagram/model';
import { first, isEmpty } from 'lodash';

@Injectable({ providedIn: 'root' })
export class WellSchematicDiagramState
    extends State<WellSchematicDiagramRecord>
    implements WellSchematicDiagramRecord
{
    records: WellSchematicDiagram[];
    applications: WellSchematicApplication[];

    constructor() {
        super();
    }

    isEmpty() {
        return isEmpty(this.records) || isEmpty(this.applications);
    }

    findByWellStringId(wellStringId: string): WellSchematic {
        return isEmpty(this.records)
            ? first(
                  this.records.filter(
                      (record) => record.wellStringId == wellStringId
                  )
              )
            : first(
                  this.applications.filter(
                      (application) => application.wellStringId == wellStringId
                  )
              );
    }
}
